(function () {
  function initNewsletterForm() {
    const forms = document.querySelectorAll('form[data-type="newsletter"]');
    if (!forms.length) return;
    forms.forEach(form => {
      const formId = form.id;
      const successMsg = form.querySelector('[data-newsletter-success-msg]');
      const errorMsg = form.querySelector('[data-newsletter-error-msg]');
      const emailInput = form.querySelector('input[type="email"]');
      const submitBtn =
        form.querySelector('[data-newsletter-submit-btn]') || form.querySelector('button[type="submit"]');
      const icon = submitBtn?.querySelector('[data-newsletter-icon]');
      const loader = submitBtn?.querySelector('[data-newsletter-loader]');
      if (!successMsg || !errorMsg || !emailInput || !submitBtn) return;    
      emailInput.addEventListener('input', () => errorMsg.classList.add('hidden'));
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const email = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) return showError('Please enter an email');
        if (!emailRegex.test(email)) return showError('Please enter a valid email');
        errorMsg.classList.add('hidden');
        toggleBtn(true);
        const params = new URLSearchParams(new FormData(form));
        fetch('/contact', {
          method: 'POST',
          body: params,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/html' },
        })
          .then((res) => {
            if (res.ok || res.type === 'opaqueredirect') showSuccess('Thank you for subscribing!');
            else if (res.status === 400) showError('Error 400 (Bad Request) occurred due to multiple retries');
            else if (res.status === 422) showSuccess("You're already subscribed!");
            else throw new Error();
          })
          .catch(() => showError('Newsletter signup failed'))
          .finally(() => toggleBtn(false));
      });
      function showError(msg) {
        errorMsg.textContent = msg;
        errorMsg.classList.remove('hidden');
        successMsg.classList.add('hidden');
        emailInput.focus();
      } 
      function showSuccess(msg) {
        successMsg.textContent = msg;
        successMsg.classList.remove('hidden');
        errorMsg.classList.add('hidden');
        form.reset();
        setTimeout(() => successMsg.classList.add('hidden'), 3000);
      }   
      function toggleBtn(isLoading) {
        submitBtn.disabled = isLoading;
        if (icon) icon.classList.toggle('hidden', isLoading);
        if (loader) loader.classList.toggle('hidden', !isLoading);
      }
    });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initNewsletterForm)
    : initNewsletterForm();
})();